/**
 * TanStack Query hooks for `auto-action-block-mark-reject-alert-on-fraud`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	summary,
	autoActionBlockMarkRejectAlertOnFraudQueryKeys,
	type CreateFraudActionBody,
	type CreateFraudActionResponse,
	type FraudActionSummaryResponse,
	type ListFraudActionsParams,
	type ListFraudActionsResponse,
} from "./api";

export function useAutoActionBlockMarkRejectAlertOnFraudList(
	params: ListFraudActionsParams = {},
): UseQueryResult<ListFraudActionsResponse, Error> {
	return useQuery({
		queryKey: autoActionBlockMarkRejectAlertOnFraudQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useAutoActionBlockMarkRejectAlertOnFraudSummary(): UseQueryResult<
	FraudActionSummaryResponse,
	Error
> {
	return useQuery({
		queryKey: autoActionBlockMarkRejectAlertOnFraudQueryKeys.summary(),
		queryFn: summary,
	});
}

export function useAutoActionBlockMarkRejectAlertOnFraudCreate(): UseMutationResult<
	CreateFraudActionResponse,
	Error,
	CreateFraudActionBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: autoActionBlockMarkRejectAlertOnFraudQueryKeys.all,
			});
		},
	});
}
